import { render, staticRenderFns } from "./managementIndex.vue?vue&type=template&id=090d138e&scoped=true&"
import script from "./managementIndex.vue?vue&type=script&lang=js&"
export * from "./managementIndex.vue?vue&type=script&lang=js&"
import style0 from "./managementIndex.vue?vue&type=style&index=0&id=090d138e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d138e",
  null
  
)

export default component.exports